import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
export default function renderLegends() {
    return [
        {
            color: 'safety-green',
            label: MessageService.translate('approvals.filtered-list-approved-checkbox'),
            value: MessageService.translate('approvals.filtered-list-approved-checkbox'),
        },
        {
            color: 'safety-orange',
            label: MessageService.translate('approvals.filtered-list-settled-checkbox'),
            value: MessageService.translate('approvals.filtered-list-settled-checkbox'),
        },
        {
            color: 'safety-red',
            label: MessageService.translate('approvals.filtered-list-disapproved-checkbox'),
            value: MessageService.translate('approvals.filtered-list-disapproved-checkbox'),
        },
        {
            color: 'safety-yellow',
            label: MessageService.translate('approvals.filtered-list-pending-checkbox'),
            value: MessageService.translate('approvals.filtered-list-pending-checkbox'),
        },
        {
            color: 'safety-blue',
            label: MessageService.translate('approvals.filtered-list-forwarded-checkbox'),
            value: MessageService.translate('approvals.filtered-list-forwarded-checkbox'),
        },
        {
            color: 'safety-hazard',
            label: MessageService.translate('reason.waiting-response-opinion'),
            value: MessageService.translate('reason.waiting-response-opinion'),
        },
    ];
}
//# sourceMappingURL=render-legends.js.map